export enum EmployeeLoginLevel {
    Company = 'Company',
    Department = 'Department',
    Team = 'Team'
}